import { ENV_LABEL, isProdEnv } from '@/lib/env';
import { cn } from '@/lib/utils';

export const EnvBadge = ({ label = ENV_LABEL }: { label?: string }) => (
  <span
    data-testid="env-badge"
    className={cn(
      'rounded px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider',
      isProdEnv(label) ? 'bg-danger text-white' : 'bg-brand-teal/15 text-brand-teal',
    )}
  >
    {label}
  </span>
);
